'use client';
import { ComponentType } from 'react';
import { PlaceholderConfig } from '@spa/lib/react/context/PlaceholderContext';
import { Props } from './teaser.component';
import dynamic from 'next/dynamic';

const DynamicTeaserComponent: ComponentType<Props> = dynamic(() => import('./teaser.component'));

export default DynamicTeaserComponent;

export function calculateTeaserPlaceholderConfig(): PlaceholderConfig {
  const heightSinceWidth = [
    { sinceWidth: 0, height: 125 },
    { sinceWidth: 425, height: 110 },
    { sinceWidth: 768, height: 170 }
  ];

  return {
    heightSinceWidth
  };
}
